<template>
  <div ref="cell" class="grid-view__cell active">
    <div class="grid-field-number">
      <SearchHighlightedText :text="value" :search-term="searchTerm" />
    </div>
  </div>
</template>

<script>
import gridField from '@baserow/modules/database/mixins/gridField'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  components: { SearchHighlightedText },
  mixins: [gridField],
}
</script>
